





































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import ClickOutside from 'v-click-outside'
import { Chrome } from 'vue-color'
import { Card, Icon } from '@alpha/ink'
import { distanceFromEdges } from '@/utilities/browser'

@Component({
  directives: {
    clickOutside: ClickOutside.directive
  },
  components: {
    ColorPicker: Chrome,
    Card,
    Icon
  }
})
export default class ColorInput extends Vue {
  @Prop({ required: true }) value!: string
  @Prop({ required: false, default: () => false }) disabled!: boolean
  color: string = this.value
  showPicker: boolean = false

  @Watch('value')
  setColor () {
    this.color = this.value
    this.showPicker = false
  }

  selectColor () {
    if (this.showPicker) {
      this.$emit('confirm')
      this.showPicker = false
    }
  }

  openPicker () {
    if (this.disabled) return
    this.showPicker = true
  }

  updateColor (newColor: { hex: string }) {
    this.color = newColor.hex
    this.$emit('change', newColor.hex)
  }

  absolutePosition () {
    const container = this.$refs.container as HTMLElement
    const { bottom, right } = distanceFromEdges(container)
    console.log({
      right,
      bottom
    })
    const alignBottom = bottom < 300
    const alignLeft = right < 500
    return {
      top: !alignBottom,
      bottom: alignBottom,
      right: !alignLeft,
      left: alignLeft,
      'absolute-wrapper': true
    }
  }
};
